import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { EnumToStringPipe } from '@app/features-modules/gestao-bolseiros/pipes/enum-to-string.pipe';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-representante-card',
  imports: [CommonModule, EnumToStringPipe, AvatarModule],
  templateUrl: './representante-card.component.html',
  styleUrls: ['./representante-card.component.scss'],
  standalone: true,
})
export class RepresentanteCardComponent implements OnChanges {
  @Input() instituicaoGestora: any;
  @Input() foto: string | ArrayBuffer | null = null;
  @Input() representantes: any;
  @Output() edit = new EventEmitter<any>();
  @Output() desativar = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() redefinirSenha = new EventEmitter<any>();
  @Output() notificar = new EventEmitter<any>();
  Show = false;
  imageError = false;

  constructor(private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.imageError = false;
  }

  ShowDetais(event: Event) {
    event.stopPropagation();
    this.Show = !this.Show;
  }

  Editar(event: Event) {
    event.stopPropagation();
    this.edit.emit(this.representantes);
  }

  RedefinirSenha(event: Event) {
    event.stopPropagation();
    this.redefinirSenha.emit(this.representantes);
  }

  Desativar(event: Event) {
    event.stopPropagation();
    this.desativar.emit(this.representantes);
  }

  deleteEvent(event: Event) {
    event.stopPropagation();
    this.delete.emit(this.representantes);
  }

  Notificar(event: Event) {
    event.stopPropagation();
    this.notificar.emit(this.representantes);
  }

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
}
